import ExpenseService from '@/services/expense.service.js'

const state = {
  expenses: [],
  unpaidExpenses: [],
  loading: false,
  currentExpense: null
}

const getters = {
  expenses: state => state.expenses,
  unpaidExpenses: state => state.unpaidExpenses,
  loading: state => state.loading,
  currentExpense: state => state.currentExpense
}
console.log('state', state)
const actions = {
  async fetchExpenses({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await ExpenseService.getExpenses(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_EXPENSES', data)
      console.log('expense data: ', data.expenses[0])
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load expenses',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchExpenseById({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await ExpenseService.getExpenseById(id)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CURRENT_EXPENSE', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load expense',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createExpense({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await ExpenseService.createExpense(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Expense created successfully',
        { root: true }
      )
      await dispatch('fetchExpenses')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to create expense',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateExpense({ commit, dispatch }, { id, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await ExpenseService.updateExpense(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Expense updated successfully',
        { root: true }
      )
      await dispatch('fetchExpenses')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update expense',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteExpense({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await ExpenseService.deleteExpense(id)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Expense deleted successfully',
        { root: true }
      )
      await dispatch('fetchExpenses')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete expense',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUnpaidExpenses({ commit, dispatch }, vendorPartyId) {
    try {
      const response = await ExpenseService.getUnpaidExpenses(vendorPartyId)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_UNPAID_EXPENSES', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load unpaid expenses',
        { root: true }
      )
      throw error
    }
  },

  clearCurrentExpense({ commit }) {
    commit('SET_CURRENT_EXPENSE', null)
  }
}

const mutations = {
  SET_EXPENSES(state, expenses) {
    console.log('Set Expense: ', expenses.expenses)
    state.expenses = expenses.expenses
  },
  SET_UNPAID_EXPENSES(state, expenses) {
    state.unpaidExpenses = expenses
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_CURRENT_EXPENSE(state, expense) {
    state.currentExpense = expense
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
